/* eslint global-require: "off" */
import i18next from 'i18next';
import {
  ApolloLink,
} from 'apollo-link';
import {
  HttpLink,
} from 'apollo-link-http';
import {
  setContext,
} from 'apollo-link-context';
// import {
//   RetryLink,
// } from 'apollo-link-retry';
import {
  onError,
} from 'apollo-link-error';
import {
  InMemoryCache,
} from 'apollo-cache-inmemory';
import {
  persistCache,
} from 'apollo-cache-persist';
import ApolloClient from 'apollo-client';
import storage from 'localforage';
import React from 'react';
import ReactDOM from 'react-dom';
import {
  createSelector,
} from 'reselect';
import {
  createBrowserHistory,
} from 'history';
import settings from './common/settings';
import {
  matchToken,
} from './common/utils/history';
import App from './containers/App';
import resolveOnSelector from './common/utilsClient/redux/resolveOnSelector';
import configureStore from './store/configureStore';
import {
  selectToken,
} from './store/token';
import isDebug from './utils/isDebug';
import './common/logger/client/register';
import './common/fonts';
import notification from './common/utilsClient/notification';
import * as serviceWorker from './serviceWorker';

const history = createBrowserHistory();
const cache = new InMemoryCache();
const waitOnCache = persistCache({
  cache,
  storage,
});

let store;
let persistor;
const authLink = setContext(async (_, {
  headers,
}) => {
  const token = await resolveOnSelector(
    store,
    createSelector(
      selectToken,
      state => state.router && state.router.location,
      (currentToken, location) => {
        const newToken = matchToken(location.hash);
        return newToken || currentToken;
      },
    ),
  );
  return {
    headers: {
      ...headers,
      Authorization: token,
    },
  };
});

const patientGraphqlUrl =
  settings && settings.public && settings.public.patientGraphqlUrl;

const errorLink = onError(({
  networkError,
  graphQLErrors,
}) => {
  if (graphQLErrors) {
    graphQLErrors.map(({
      message,
      locations,
      path,
    }) => console.log(
      `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
    ));
  }
  if (networkError) {
    if (networkError.statusCode === 401) {
      const key = 'jwterror';
      notification.error({
        key,
        message: i18next.t('jwterror'),
        duration: 0,
      });
    }
  }
});

const client = new ApolloClient({
  link: ApolloLink.from([
    authLink,
    // new RetryLink({
    //   delay: {
    //     initial: 300,
    //     max: Infinity,
    //     jitter: true,
    //   },
    //   attempts: {
    //     max: 10,
    //     retryIf: error => error.statusCode !== 401,
    //   },
    // }),
    errorLink,
    new HttpLink({
      uri: patientGraphqlUrl,
      fetchOptions: {
        mode: 'cors',
        credentials: 'same-origin',
      },
    }),
  ]),
  cache,
  connectToDevTools: isDebug,
});

({
  store,
  persistor, // eslint-disable-line prefer-const
} = configureStore({
  history,
  client,
  cache,
}));

const initialLoading = Promise.all([
  waitOnCache,
  resolveOnSelector(persistor, 'bootstrapped'),
]);

ReactDOM.render(
  <App
    store={store}
    history={history}
    client={client}
    promise={initialLoading}
  />,
  document.getElementById('root'),
);

if (process.env.NODE_ENV !== 'production') {
  if (typeof module !== 'undefined' && module.hot) {
    module.hot.accept('./containers/App', () => {
      const NextApp = require('./containers/App').default;
      ReactDOM.render(
        <NextApp
          store={store}
          history={history}
          client={client}
          promise={initialLoading}
        />,
        document.getElementById('root'),
      );
    });
  }
}

serviceWorker.register({
  onUpdate: (registration) => {
    if (registration.waiting) {
      registration.waiting.addEventListener('statechange', (event) => {
        if (event.target.state === 'activated') {
          window.location.reload();
        }
      });

      registration.waiting.postMessage({
        type: 'SKIP_WAITING',
      });
    }
  },
});
